import { useMemo } from 'react';

import { ModuleFilter } from '@suntex.fim/hub';

import { usePlayerContext } from '../context';
import { getFocusOptions, getModuleTagsForGradeLevels } from '../utils/focus';

export interface ModuleAccessFilter {
  enable: ModuleFilter;
  disable: ModuleFilter;
}

/**
 * Derives module access filters from the player's focus mode, matching the
 * same logic used by the Hub to determine which modules are visible.
 */
export function useModuleAccessFilters(): ModuleAccessFilter {
  const { playerInfo } = usePlayerContext();

  const enable = useMemo(
    () =>
      playerInfo
        ? getModuleTagsForGradeLevels(getFocusOptions(playerInfo))
        : undefined,
    [playerInfo],
  );

  return { enable, disable: undefined };
}
